import { render, staticRenderFns } from "./ResultTestEntrance.vue?vue&type=template&id=702a93dc&scoped=true"
import script from "./ResultTestEntrance.vue?vue&type=script&lang=js"
export * from "./ResultTestEntrance.vue?vue&type=script&lang=js"
import style0 from "./ResultTestEntrance.vue?vue&type=style&index=0&id=702a93dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702a93dc",
  null
  
)

export default component.exports